import * as THREE from 'three';
// import { loadJSON } from '../helpers/JSONHelper.js';

// export async function loadCurveFromJSON(jsonPath) {

// 	const curveJSON = await loadJSON(jsonPath);
// 	const curve = createCurveFromJSON(curveJSON);
// 	const curveTubeMesh = getTubeFromCurve(curve);

// 	const curveAndMesh = {
// 		curve: curve,
// 		mesh: curveTubeMesh
// 	}
// 	return curveAndMesh
// }

export type JsonPathType = {
  points: { x: number; y: number; z: number }[];
  closed: boolean;
};

// const useCreateCurveFromJSON = useCallback((json: JsonPathType)=> {

//   // Extract the vertices array from the JSON object
//   const vertices = json.points;

//   // Create an empty array to store THREE.Vector3 instances
//   const points = [];

//   // Iterate over the vertices and push THREE.Vector3 instances to the points array
//   for (let i = 0; i < vertices.length; i += 3) {
//     const x = vertices[i].x;
//     const y = vertices[i].y;
//     const z = vertices[i].z;
//     points.push(new THREE.Vector3(x, y, z));
//   }

//   // Create a CatmullRomCurve3 using the points array
//   const curve = new THREE.CatmullRomCurve3(points);

//   curve.closed = json.closed;

//   return curve;

// },[])

function createCurveFromJSON(json: JsonPathType) {
  // Extract the vertices array from the JSON object
  const vertices = json.points;

  // Create an empty array to store THREE.Vector3 instances
  const points = [];

  const line3Curves = [];

  // Iterate over the vertices and push THREE.Vector3 instances to the points array
  for (let i = 0; i < vertices.length; i += 3) {
    const x = vertices[i].x;
    const y = vertices[i].y;
    const z = vertices[i].z;
    points.push(new THREE.Vector3(x, y, z));
  }

  // Create a CatmullRomCurve3 using the points array
  const curve = new THREE.CatmullRomCurve3(points);

  curve.closed = json.closed;

  const catmulPoints = curve.getPoints(100);

  for (let i = 0; i < catmulPoints.length - 1; i++) {
    line3Curves.push(
      new THREE.LineCurve3(catmulPoints[i], catmulPoints[i + 1])
    );
  }

  return { curve, points, line3Curves };
}

function getTubeFromCurve(curve) {
  const geometry = new THREE.TubeGeometry(curve, 100, 0.05, 8, curve.closed);
  const material = new THREE.MeshBasicMaterial({
    color: 0xffffff,
    wireframe: true,
    side: THREE.DoubleSide,
  });
  const mesh = new THREE.Mesh(geometry, material);

  return mesh;
}

function getLineCurve3FromJson(json: JsonPathType) {
  // Extract the vertices array from the JSON object
  const vertices = json.points;

  // Create an empty array to store THREE.Vector3 instances
  const points = [];

  const curves = [];

  for (let i = 0; i < vertices.length; i += 3) {
    const x = vertices[i].x;
    const y = vertices[i].y;
    const z = vertices[i].z;
    points.push(new THREE.Vector3(x, y, z));
  }

  for (let i = 0; i < points.length - 1; i++) {
    curves.push(new THREE.LineCurve3(points[i], points[i + 1]));
  }

  return curves;
}

export { createCurveFromJSON, getLineCurve3FromJson };
